import Vue from 'vue'
import VueAMap from 'vue-amap'

import App from './components/datav/App.vue'

import store from './store'

import './assets/common.less'

import dataV from '@jiaminghi/data-view'

Vue.prototype.$echarts = window.echarts

Vue.config.productionTip = false

Vue.use(dataV)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '8e5a30cce64a5ed72c712a1a4a6e2f57',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})
new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
